import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import {FormGroup, FormBuilder, AbstractControl} from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { SharedService } from '../../shared/shared.service';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {DtoInactivity} from "./models/DtoInactivity";
import {SettingsPlannerService} from "./settings-planner.service";

@Component({
    selector: 'inactivity',
    template: require('./inactivity.component.html'),
    styles: [require('./inactivity.component.css')]
})
@AutoUnsubscribe()

export class InactivityComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;
    dtoObject: DtoInactivity;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsPlannerService,
                private ss: SharedService) { }

    ngOnInit() {
        this.form = this.fb.group({
            dateTime: [{value: null, disabled: this.id > 0}, [SharedValidators.customRequired, this.validateBeginDate.bind(this)]],
            dateTimeUntill: [{value: null, disabled: this.id > 0}, [SharedValidators.customRequired, this.validateEndDate.bind(this)]],
            from: [null, [SharedValidators.customRequired, this.validateBeginTime.bind(this)]],
            to: [null, [SharedValidators.customRequired, this.validateEndTime.bind(this)]],
            reason: null,
            present: null
        });

        if (this.id > 0) {
            this.ds.getInactivityById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                });
        }
        else {
            this.dtoObject = {
                id: 0,
                present: true,
                from: this.ss.createDateTime(2000,1,1,9,0,0),
                to: this.ss.createDateTime(2000,1,1,18,0,0),
                dateTime: this.ss.getCurrentDateOnly(),
                dateTimeUntill: this.ss.getCurrentDateOnly()
            };
            if (this.copyFromId > 0) {
                this.ds.getInactivityById(this.copyFromId)
                    .subscribe(response => {
                        this.dtoObject.dateTime = response.dateTime;
                        this.dtoObject.dateTimeUntill = response.dateTime;
                        this.dtoObject.to = response.to;
                        this.dtoObject.from = response.from;
                        this.dtoObject.present = response.present;
                        this.dtoObject.reason = response.reason;
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    });
            }
            else {
                this.fs.patchDtoToForm(this.dtoObject, this.form);
            }
        }

        this.form.get('dateTime').valueChanges.subscribe((newVal) => {
            this.form.patchValue([{'dateTimeUntill': newVal}]);
        });

        this.form.valueChanges.subscribe(() => {
            if (this.validationMessage) this.validationMessage.getFormValidationErrors();
        });
    }

    validateEndDate(control: AbstractControl) {
        if (control.dirty) {
            if (control.value < this.form.value.dateTime)
                return { endDateBeforeBegin: true };
            else if (this.ss.getYearFromDate(control.value) !== this.ss.getYearFromDate(this.form.value.dateTime))
                return { endDateOtherYearAsBegin: true };
            else {
                this.form.get('dateTime').setErrors(null);
                return null;
            }
        }

        return null;
    }

    validateBeginDate(control: AbstractControl) {
        if (control.dirty) {
            if (control.value > this.form.value.dateTimeUntill)
                return { endDateBeforeBegin: true };
            else if (this.ss.getYearFromDate(control.value) !== this.ss.getYearFromDate(this.form.value.dateTimeUntill))
                return { endDateOtherYearAsBegin: true };
            else {
                this.form.get('dateTimeUntill').setErrors(null);
                return null;
            }
        }

        return null;
    }

    validateBeginTime(control: AbstractControl) {
        if (control.dirty) {
            if (control.value > this.form.value.to)
                return { endTimeBeforeBegin: true };
            else {
                this.form.get('to').setErrors(null);
                return null;
            }
        }

        return null;
    }

    validateEndTime(control: AbstractControl) {
        if (control.dirty) {
            if (control.value < this.form.value.from)
                return { endTimeBeforeBegin: true };
            else {
                this.form.get('from').setErrors(null);
                return null;
            }
        }

        return null;
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveInactivity(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-planner/inactivity.component.ts